import { createStore } from 'vuex';
import favorites from '@/store/legacy/searchInfo/favorites';
import filters from '@/store/legacy/searchInfo/filters';
import homeContent from './homeContent';
// Search store
const searchModule = {
  state: () => ({
    data: null,
  }),
  mutations: {},
  actions: {},
  getters: {},
};
const store = createStore({
  modules: {
    favorites,
    filters,
    search: searchModule,
    homeContent,
  },
});

export default store;
